<jw-modal id='jobSignOffRescheduleModal'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <h1 class='header'>Reschedule Job</h1>

  <div class='alert alert-danger'>
    Warning! This will move this order to another day and remove the current job off the timeline. Make sure this is what you want before continuing.
  </div>
  <div class='form-group'>
    <div class="form-group col-md-4">
      <label for="inputEmail4">Date *</label>
      <input type="date" name='name' [(ngModel)]='this.job.order.date' [class.is-invalid]='!this.job.order.date' class="form-control" id="inputEmail4">
    </div>
    <div class="form-group col-md-4">
      <label for="inputEmail4">Time *</label>
      <input type="time" name='name' [(ngModel)]='this.job.order.time' [class.is-invalid]='!this.job.order.time' class="form-control" id="inputEmail4">
    </div>
  </div>
  <button class='btn btn-success' (click)='this.save()'>Save</button>&nbsp;
  <button class='btn btn-danger' (click)='this.close()' style='display:none;'>Cancel</button>
</jw-modal>
